export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "UU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "NU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "ZU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "ZU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "ZU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "ZU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "ZU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		tier: "ZU",
	},
	pikachu: {
		tier: "ZU",
	},
	raichu: {
		tier: "ZUBL",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "NU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "NU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "ZU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "ZU",
	},
	crobat: {
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NU",
	},
	bellossom: {
		tier: "PU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "ZU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "NU",
	},
	diglett: {
		tier: "ZU",
	},
	dugtrio: {
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "ZU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "PU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "NU",
	},
	politoed: {
		tier: "PU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "PU",
	},
	alakazam: {
		tier: "UU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PU",
	},
	machamp: {
		tier: "Uber",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "PU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "(OU)",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "NU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "PU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "UU",
	},
	slowking: {
		tier: "NU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NU",
	},
	magnezone: {
		tier: "OU",
	},
	farfetchd: {
		tier: "ZU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "NU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "ZU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "PU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "UU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
	},
	gengar: {
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "UU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "NU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "ZUBL",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "NU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "UU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "ZUBL",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "UU",
	},
	hitmonchan: {
		tier: "NU",
	},
	hitmontop: {
		tier: "UU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "NU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "UU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "PU",
	},
	rhyperior: {
		tier: "UU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		tier: "OU",
	},
	tangela: {
		tier: "PU",
	},
	tangrowth: {
		tier: "UU",
	},
	kangaskhan: {
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "OU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "ZU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "PU",
	},
	scyther: {
		tier: "UU",
	},
	scizor: {
		tier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "NU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "ZUBL",
	},
	electivire: {
		tier: "(OU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "PU",
	},
	magmortar: {
		tier: "NU",
	},
	pinsir: {
		tier: "PU",
	},
	tauros: {
		tier: "NU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "OU",
	},
	lapras: {
		tier: "ZUBL",
	},
	ditto: {
		tier: "ZU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "(OU)",
	},
	jolteon: {
		tier: "(OU)",
	},
	flareon: {
		tier: "ZU",
	},
	espeon: {
		tier: "NUBL",
	},
	umbreon: {
		tier: "(OU)",
	},
	leafeon: {
		tier: "UU",
	},
	glaceon: {
		tier: "PU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "NU",
	},
	porygonz: {
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "UU",
	},
	aerodactyl: {
		tier: "OU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "(OU)",
	},
	articuno: {
		tier: "PUBL",
	},
	zapdos: {
		tier: "OU",
	},
	moltres: {
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "PU",
	},
	dragonite: {
		tier: "OU",
	},
	mewtwo: {
		tier: "Uber",
	},
	mew: {
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "NU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "NU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "ZU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "ZU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "ZU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "ZU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "ZU",
	},
	togekiss: {
		tier: "(OU)",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "PU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "PU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "UU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "ZU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "NU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "UU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "ZU",
	},
	yanma: {
		tier: "ZU",
	},
	yanmega: {
		tier: "UUBL",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "PU",
	},
	murkrow: {
		tier: "PU",
	},
	honchkrow: {
		tier: "UUBL",
	},
	misdreavus: {
		tier: "PU",
	},
	mismagius: {
		tier: "UU",
	},
	unown: {
		tier: "ZU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		tier: "Uber",
	},
	girafarig: {
		tier: "ZU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "OU",
	},
	dunsparce: {
		tier: "ZU",
	},
	gligar: {
		tier: "NU",
		doublesTier: "LC",
	},
	gliscor: {
		tier: "OU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "ZU",
	},
	qwilfish: {
		tier: "UU",
	},
	shuckle: {
		tier: "ZU",
	},
	heracross: {
		tier: "UUBL",
	},
	sneasel: {
		tier: "PU",
	},
	weavile: {
		tier: "(OU)",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "UU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "ZU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
	},
	mamoswine: {
		tier: "(OU)",
	},
	corsola: {
		tier: "ZU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "ZU",
	},
	delibird: {
		tier: "ZU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "PU",
	},
	skarmory: {
		tier: "OU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "UU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
	},
	stantler: {
		tier: "ZU",
	},
	smeargle: {
		tier: "(OU)",
	},
	miltank: {
		tier: "UU",
	},
	raikou: {
		tier: "UUBL",
	},
	entei: {
		tier: "NUBL",
	},
	suicune: {
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
	},
	lugia: {
		tier: "Uber",
	},
	hooh: {
		tier: "Uber",
	},
	celebi: {
		tier: "OU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "UU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		tier: "UU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "ZU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "PUBL",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "ZU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "ZU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "UU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "NU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "UU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "ZU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "NU",
	},
	gallade: {
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "ZU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "ZU",
	},
	slaking: {
		tier: "ZU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "(OU)",
	},
	shedinja: {
		tier: "ZU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "ZU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "UU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "ZU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "ZU",
	},
	sableye: {
		tier: "ZU",
	},
	mawile: {
		tier: "ZU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "UU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "NU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "NU",
	},
	plusle: {
		tier: "ZU",
	},
	minun: {
		tier: "ZU",
	},
	volbeat: {
		tier: "ZU",
	},
	illumise: {
		tier: "ZU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "PUBL",
	},
	roserade: {
		tier: "OU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "ZU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "NU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "ZU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "ZU",
	},
	torkoal: {
		tier: "PU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "NU",
	},
	spinda: {
		tier: "ZU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "UU",
	},
	zangoose: {
		tier: "PU",
	},
	seviper: {
		tier: "ZU",
	},
	lunatone: {
		tier: "ZU",
	},
	solrock: {
		tier: "PU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "ZU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "ZU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "UU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "NU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "PU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "UU",
	},
	castform: {
		tier: "ZU",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		tier: "ZU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "ZU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NU",
	},
	dusknoir: {
		tier: "(OU)",
	},
	tropius: {
		tier: "ZU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "ZU",
	},
	absol: {
		tier: "UU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "PU",
	},
	froslass: {
		tier: "UUBL",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "ZUBL",
	},
	clamperl: {
		tier: "ZU",
	},
	huntail: {
		tier: "ZU",
	},
	gorebyss: {
		tier: "ZUBL",
	},
	relicanth: {
		tier: "PU",
	},
	luvdisc: {
		tier: "ZU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "ZU",
	},
	salamence: {
		tier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "PU",
	},
	metagross: {
		tier: "OU",
	},
	regirock: {
		tier: "NU",
	},
	regice: {
		tier: "NU",
	},
	registeel: {
		tier: "UU",
	},
	latias: {
		tier: "OU",
	},
	latios: {
		tier: "Uber",
	},
	kyogre: {
		tier: "Uber",
	},
	groudon: {
		tier: "Uber",
	},
	rayquaza: {
		tier: "Uber",
	},
	jirachi: {
		tier: "OU",
	},
	deoxys: {
		tier: "Uber",
	},
	deoxysattack: {
		tier: "Uber",
	},
	deoxysdefense: {
		tier: "Uber",
	},
	deoxysspeed: {
		tier: "Uber",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "UU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "PU",
	},
	infernape: {
		tier: "OU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		tier: "OU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UUBL",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "ZU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "ZU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "ZU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "ZUBL",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "ZU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "ZU",
	},
	wormadamsandy: {
		tier: "ZU",
	},
	wormadamtrash: {
		tier: "ZU",
	},
	mothim: {
		tier: "ZU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "ZU",
	},
	pachirisu: {
		tier: "ZU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "NU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "ZU",
	},
	cherrimsunshine: {
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "PU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		tier: "NU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "ZU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "PU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "NU",
	},
	bronzor: {
		tier: "ZU",
	},
	bronzong: {
		tier: "OU",
	},
	chatot: {
		tier: "ZU",
	},
	spiritomb: {
		tier: "UU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "PU",
	},
	garchomp: {
		tier: "Uber",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "OU",
	},
	hippopotas: {
		tier: "NUBL",
	},
	hippowdon: {
		tier: "OU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "UU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "UU",
	},
	carnivine: {
		tier: "ZU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "ZU",
	},
	snover: {
		tier: "NUBL",
	},
	abomasnow: {
		tier: "UUBL",
	},
	rotom: {
		tier: "UU",
	},
	rotomheat: {
		tier: "OU",
	},
	rotomwash: {
		tier: "OU",
	},
	rotomfrost: {
		tier: "OU",
	},
	rotomfan: {
		tier: "OU",
	},
	rotommow: {
		tier: "OU",
	},
	uxie: {
		tier: "UU",
	},
	mesprit: {
		tier: "UU",
	},
	azelf: {
		tier: "OU",
	},
	dialga: {
		tier: "Uber",
	},
	palkia: {
		tier: "Uber",
	},
	heatran: {
		tier: "OU",
	},
	regigigas: {
		tier: "PU",
	},
	giratina: {
		tier: "Uber",
	},
	giratinaorigin: {
	},
	cresselia: {
		tier: "UUBL",
	},
	phione: {
		tier: "ZU",
	},
	manaphy: {
		tier: "Uber",
	},
	darkrai: {
		tier: "Uber",
	},
	shaymin: {
		tier: "(OU)",
	},
	shayminsky: {
		tier: "Uber",
	},
	arceus: {
		tier: "AG",
	},
	arceusbug: {
	},
	arceusdark: {
	},
	arceusdragon: {
	},
	arceuselectric: {
	},
	arceusfighting: {
	},
	arceusfire: {
	},
	arceusflying: {
	},
	arceusghost: {
	},
	arceusgrass: {
	},
	arceusground: {
	},
	arceusice: {
	},
	arceuspoison: {
	},
	arceuspsychic: {
	},
	arceusrock: {
	},
	arceussteel: {
	},
	arceuswater: {
	},
};
